export function fireOnceUponEventEnd(func, time = 250) {
  window.clearTimeout(fireOnceUponEventEnd.isFinished);
  fireOnceUponEventEnd.isFinished = setTimeout(() => {
    fireOnceUponEventEnd.isFinished = null;
    func();
  }, time);
}